import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule, OnInit, ViewEncapsulation, Renderer2, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule, Router } from '@angular/router';
import { ToolbarButtonModule } from '@app/components/header/toolbar-button/toolbar-button.component';
import { LinkModule } from '@app/directives/link.directive';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Constants } from '@app/common/constants';
import { filter, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFormComponent implements OnInit, OnDestroy {

  subscriptions = new Subscription();
  @ViewChild('searchInput', { static: true }) searchInputElement: ElementRef<any>;

  constructor(private router: Router, private renderer: Renderer2, private changeDetectorRef: ChangeDetectorRef, private dialog: MatDialog) { }

  private isLetter(character: any) {
    return character.toLowerCase() !== character.toUpperCase();
  }

  onKeyUp(event: Event) {
    if (event instanceof KeyboardEvent) {
      const element = event.target as HTMLInputElement;
      if (element && element.value) {
        this.renderer.setValue(element, '');
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  onElementClick(event: Event) {
    let query = '';

    if (event instanceof KeyboardEvent) {
      /* tslint:disable */
      if (event.key && (event.key !== 'Enter' || event.keyCode !== 13) && event.key.length > 0 && this.isLetter(event.key)) {
        /* tslint:enable */
        query = event.key;
      }
    }

    this.router.navigate(['', { outlets: { modal: ['search'] } }], { queryParams: { q: query } });
  }

  ngOnInit() {
    this.subscriptions.add(
      this.dialog
        .afterOpened
        .pipe(
          filter((dialogRef) => dialogRef.id === Constants.SEARCH_DIALOG_ID),
          mergeMap((dialogRef) => {
            this.searchInputElement?.nativeElement?.blur();
            this.changeDetectorRef.detectChanges();
            return dialogRef.afterClosed();
          }))
        .subscribe((handleModalCloseFromComponent) => {
          // When the search component dialog is closed there are some cases where we navigate to another route and then i dont think we need to refocus.
          if (!handleModalCloseFromComponent) {
            this.searchInputElement?.nativeElement?.focus();
          }
        }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
@NgModule({
  declarations: [SearchFormComponent],
  exports: [SearchFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    ToolbarButtonModule,
    LinkModule,
    RouterModule
  ]
})
export class SearchFormModule { }
